import React, { Fragment } from 'react'
import { Route } from 'react-router-dom'
import List from './List'
import Edit from './Edit'
import Create from './Create'

const Users = ({ match }) => (
  <Fragment>
    <Route exact path={match.url} component={List} />
    <Route path={`${match.url}/edit/:id`} component={Edit} />
    <Route path={`${match.url}/add`} component={Create} />
  </Fragment>
)

export default Users
